import React from "react"

import DineroFactory from "dinero.js"

import {
  ActionWrapper,
  CartItemContainer,
  InfoWrapper,
  ItemDetails,
  ItemImage,
  ItemName,
  ItemPrice
} from "./CartItem.styled"
import Money from "../../../../Money"

import placeholder from "../../../../../images/placeholder.svg"
import { OrderGift, ReleaseGift } from "lib/types/generated/graphql-types"


type Props = {
  item: ReleaseGift
  currencyCode?: string
  orderGift: OrderGift | undefined
}

const GiftItem = ({ item, currencyCode, orderGift, ...props }: Props) => {

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = placeholder
  }

  return (
    <CartItemContainer {...props}>
      <InfoWrapper>
        <ItemImage>
          <img src={orderGift?.imageUrl ?? ""} onError={handleImageError} />
        </ItemImage>
        <ItemDetails>
          <ItemName>{orderGift?.name}</ItemName>
          <ItemPrice>
            <Money
              amount={Number(orderGift?.totalPriceAmount)}
              currencyUnit={currencyCode as DineroFactory.Currency}
            />
            {orderGift && orderGift?.salePriceAmount < orderGift?.basePriceAmount && (
              <span>
                <Money
                  amount={Number(orderGift?.totalPriceAmount ?? 0)}
                  currencyUnit={currencyCode as DineroFactory.Currency}
                />
              </span>
            )}
          </ItemPrice>
        </ItemDetails>
      </InfoWrapper>

      <ActionWrapper>
        <span>
          <b>Action:</b> Will be released
        </span>
        <span>
          <b>Items to release:</b>
            <span>{item.quantity}</span>
        </span>
        <span>
          <b>Amount to be released:</b>{" "}
          <Money amount={orderGift?.totalPriceAmount ?? 0} currencyUnit={currencyCode as DineroFactory.Currency} />
        </span>
        <hr/>
      </ActionWrapper>
    </CartItemContainer>
  )
}

export default GiftItem
